// ThemeContext.js
import React, { createContext, useState } from "react";

export const ThemeContext = createContext();

export const ThemeProvider = ({ children }) => {
  const [theme, setTheme] = useState("theme-black"); // default theme

  return (
    <ThemeContext.Provider value={{ theme, setTheme }}>
      <div >{children}</div>
    </ThemeContext.Provider>
  );
};
